import { render, staticRenderFns } from "./Whiteboard.vue?vue&type=template&id=1952cc46"
import script from "./Whiteboard.vue?vue&type=script&lang=ts"
export * from "./Whiteboard.vue?vue&type=script&lang=ts"
import style0 from "./Whiteboard.vue?vue&type=style&index=0&id=1952cc46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports